<mat-toolbar class="toolbar">
    <span>{{ "Add Vacancy" | translate }}</span>
    <span class="example-spacer"></span>
    <button mat-icon-button mat-dialog-close aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</mat-toolbar>
<div mat-dialog-content class="pb-0 m-0 content" fxLayout="column">
    <form name="form" [formGroup]="form" (ngSubmit)="form.valid && onSubmit()">
        <mat-card fxLayout="row wrap">
            <div fxFlex="100">
                <mat-form-field class="example-full-width mt-12" appearance="fill">
                    <mat-label>{{ "Members" | translate }}</mat-label>
                  <input
                    #myInput
                    (keyup)="OnInput(myInput.value)"
                    type="text"
                    aria-label="Number"
                    matInput
                    class="font-weight-900"
                    readonly
                    
                  />
                  <!-- <mat-spinner matSuffix diameter="20" *ngIf="isWait"></mat-spinner> -->
                  <mat-card-content class="primary-50">
                    <div
                      fxLayout="row flex-wrap"
                      class="p-16 pt-0 line-height-1.75 mr-12 ml-12 mb-12 mt-0"
                    >
                      <ng-container>
                        <!-- *ngFor="let member of organisers; trackBy: trackByFn" -->
                      
                        <div
                          class="mt-12 mr-12">
                          <!-- *ngIf="member.participant_type == 127" -->
                        
                          <mat-card class="example-card p-0" >
                            
                            <mat-card-header class="head">
                             <div mat-card-avatar >
                                 <img
                                 style="border-radius:0px !important;"
                                  mat-card-image
                                  class="profile-img"
                                  (error)="errorHandler($event)"
                                  src="{{ member_image }}"
                                  alt="{{ member_name }}"
                                />
                              </div>
                              <mat-card-title class="namesize">{{
                                member_name
                              }}</mat-card-title>
                              <mat-card-subtitle>{{
                                member_id
                              }}</mat-card-subtitle>
                              <!-- <button
                                mat-icon-button
                                fuseWidgetToggle
                                class="fuse-widget-flip-button"
                                aria-label="Flip widget"
                                (click)="removeOrganiser(member)"
                              >
                                <mat-icon class="s-16">close</mat-icon>
                              </button> -->
                            </mat-card-header>
                          </mat-card>
                        </div>
                      </ng-container>
                    </div>
                  </mat-card-content>
                </mat-form-field>
            </div>
            <div fxFlex="100">
                <mat-form-field appearance="outline">
                    <mat-label>{{ "Open Date" | translate }}</mat-label>
                    <input matInput [min]="minDate" [matDatepicker]="picker" name="open_date" class="form-control"
                        formControlName="open_date" [(ngModel)]="open_date" [ngClass]="{
                        'is-invalid': form.get('open_date').touched && form.get('open_date').invalid
                        }" (dateChange)="onClickOpenDate($event)" required>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
            <!-- <div fxFlex="100">
                <mat-form-field appearance="outline">
                    <mat-label>{{ "Closing Date" | translate }}</mat-label>
                    <input matInput [min]="minDate_Close_Date" [matDatepicker]="picker1" name="close_date"
                        class="form-control" formControlName="close_date" [(ngModel)]="close_date" [ngClass]="{
                        'is-invalid': form.get('close_date').touched && form.get('close_date').invalid
                        }" (dateChange)="onClickCloseDate($event)" required>
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
            </div> -->
            <!-- <div fxFlex="100">
                <mat-form-field appearance="outline">
                    <mat-label>{{ "Completion Date" | translate }}</mat-label>
                    <input matInput [min]="minDate_Decision_Date" 
                        [matDatepicker]="picker1" 
                        name="decision_date"
                        class="form-control" 
                        formControlName="decision_date" 
                        [(ngModel)]="decision_date" 
                        [ngClass]="{
                        'is-invalid': form.get('decision_date').touched && form.get('decision_date').invalid
                        }" 
                        required>
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
            </div> -->
            <div fxFlex="100">
                <mat-form-field appearance="outline">
                    <mat-label>{{ "Specifications" | translate }}</mat-label>
                    <textarea matInput name="specifications" class="form-control" formControlName="specifications"
                        [(ngModel)]="specifications"> </textarea>
                </mat-form-field>
            </div>
            <div fxFlex="100" class="mt-12" style="text-align: center;">
                <button mat-raised-button class="mr-4 p-5 red" mat-dialog-close
                    aria-label="Close dialog">{{ "Cancel" | translate }}</button>
                <button [disabled]="form.invalid" mat-raised-button
                    class="ml-4 green-600">{{ "Submit" | translate }}</button>
            </div>
        </mat-card>
    </form>
</div>